const hostname = window && window.location && window.location.hostname;

let adminApiHost = 'menu.dev-saucey-api2.com';
let environment = "dev";
let typesenseHost = "ts.saucey-api2.com";
let typesenseKey = "tUfJWWTqFHrnchNKuXCvgVYgp5UuAQWBVpUpc2Mx41SxnAPsWTQC25rF0iHD5OkE";
let typesenseCollection = "development_products_v2"
let typesensePricingCollection = "development_pricing"
if (!!process.env.REACT_APP_API_ENV) {
  switch (process.env.REACT_APP_API_ENV) {
    case 'local':
      adminApiHost = 'localhost:1234';
      environment = "local"
      break;
    case 'typesense':
    case 'development':
      adminApiHost = 'menu.dev-saucey-api2.com'
      environment = "dev"
      break;
    case 'ts-prod':
    case 'production':
      adminApiHost = 'menu.saucey-api2.com';
      environment = "prod"
      typesenseCollection = "production_products_v2"
      typesensePricingCollection = "production_pricing"
      break;
    default:
      break;
  }
} else {
  if (hostname.includes('local') && process.env.REACT_APP_API_ENV !== 'local') {
    adminApiHost = 'localhost:1234';
    environment = "local"
  }
  if (hostname.includes('dev') || hostname.includes('typesense')) {
    adminApiHost = 'menu.dev-saucey-api2.com';
    environment = "dev"
  } else {
    adminApiHost = 'menu.saucey-api2.com';
    environment = "prod"
    typesenseCollection = "production_products_v2"
    typesensePricingCollection = "production_pricing"
  }
}
// Use http:// for localhost, otherwise use protocol-relative URL
export const ADMIN_API_ROOT = adminApiHost.includes('localhost') 
  ? `http://${adminApiHost}` 
  : `//${adminApiHost}`;
export const APP_LOGO = "https://web.saucey.com/dist/images/c5ca5259d190b9cd96475c4e10f5ea61.svg";
export const APP_NAME = "Saucey";
export const LOGIN_SCHEME = "username";
export const AUTH_BG = "https://cc.heyemjay.com/static/media/background-2.e2e637ac.jpg";
export const TYPESENSE_HOST = typesenseHost;
export const TYPESENSE_KEY = typesenseKey;
export const TYPESENSE_COLLECTION = typesenseCollection;
export const TYPESENSE_PRICING_COLLECTION = typesensePricingCollection;
